export default __webpack_public_path__ + "static/media/doc.816dae15.png";